// extracted by mini-css-extract-plugin
export default {"container":"O0-z","heading":"P0-z","links":"Q0-z","copy":"R0-z","subCopy":"S0-z","linksLeft":"T0-z","linksCenter":"U0-z","linksRight":"V0-z","link":"W0-z","onlyLink":"X0-z"};